import { Box, TextField } from '@mui/material';
import { Path, useController, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import type { ReportDefinition } from '../../../types';

export function HeaderBackgroundColorPicker() {
  const { $t } = useIntl();
  const { control } = useFormContext<ReportDefinition>();

  // Use useController for color field to handle custom conversion
  // between 6-char (RRGGBB) and 8-char (AARRGGBB) hex formats
  const {
    field: colorField,
    fieldState: { error },
  } = useController<ReportDefinition, Path<ReportDefinition>>({
    control,
    name: 'data.branding.headerBackground' as Path<ReportDefinition>,
    defaultValue: 'FFFFFFFF',
  });

  // Convert 8-character hex (AARRGGBB) to 6-character hex (RRGGBB) for color input
  const headerBackground8Char = (colorField.value as string) || 'FFFFFFFF';
  const headerBackground6Char =
    headerBackground8Char.length === 8
      ? headerBackground8Char.slice(2) // Remove alpha channel (first 2 chars)
      : headerBackground8Char;

  // Convert 6-character hex (RRGGBB) to 8-character hex (AARRGGBB) with full opacity
  const handleColorChange = (color6Char: string) => {
    // Ensure it's a valid hex color
    const hex = color6Char.replace('#', '').toUpperCase();
    if (hex.length === 6 && /^[0-9A-F]{6}$/.test(hex)) {
      // Add FF prefix for full opacity (AARRGGBB format)
      colorField.onChange(`FF${hex}`);
    }
  };

  return (
    <Box>
      <TextField
        sx={{ width: 200 }}
        size="small"
        type="color"
        label={$t({
          id: 'audit.branding.headerBackgroundColor',
          defaultMessage: 'Color de fondo del encabezado',
        })}
        value={`#${headerBackground6Char}`}
        onChange={(e) => {
          const color = e.target.value.replace('#', '').toUpperCase();
          handleColorChange(color);
        }}
        onBlur={colorField.onBlur}
        error={!!error}
        helperText={error?.message}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          style: {
            height: 40,
          },
        }}
      />
    </Box>
  );
}
